
import { Vue, Options } from "vue-class-component";
import { SttHangingController } from "@/app/ui/controllers/SttHangingController";
import { ActivitiesDetail, HistoryFollowUpIncoming, HistoryFollowUpIncomingEntities, HistoryFollowUpIncomingRequest } from "@/domain/entities/HangingIncoming";
import { debounce } from "lodash";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import { Pagination } from "@/domain/entities/Pagination";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import moment from "moment";

@Options({
  components: {
    PaginationV3,
  }
})

class TabRiwayatFollowUpIncoming extends Vue {
  isLoading = false;
  errorState = "";
  filterDate = new Date();
  filter = new HistoryFollowUpIncomingRequest();
  historyFollowUpIncoming: HistoryFollowUpIncoming[] = [];
  pagination = new Pagination(1, 10)
  maxDate = new Date();

  get renderedData() {
    return this.historyFollowUpIncoming.flatMap(obj => obj.activities).length
  }

  setDateRange([startDate, endDate]: string[]) {
    this.filter = new HistoryFollowUpIncomingRequest({
      ...this.filter,
      page: 1,
      startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
      endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : ""
    });
    startDate && endDate && this.getFilter(this.filter);
  }

  get activityType() {
    return [
      { name: this.$t("dashboard.hanging.allActivities"), value: "" },
      { name: this.$t("dashboard.hanging.followUpAirport"), value: "follow_up_airport" },
      { name: this.$t("dashboard.hanging.followUpCourierTruck"), value: "follow_up_courier_truck" },
      { name: this.$t("dashboard.hanging.followUpChecker"), value: "follow_up_checker" },
      { name: this.$t("dashboard.hanging.searchSttWarehouse"), value: "follow_up_warehouse" },
      { name: this.$t("dashboard.hanging.followUpConsole"), value: "follow_up_konsol" },
    ];
  }

  activityTypeSelect = false;
  onOpenActivityType(value: boolean) {
    this.activityTypeSelect = value;
  }

  onSelectActivityType(_: string, value: string) {
    this.filter.activityType = value;
    this.filter.page = 1;
    this.onOpenActivityType(false);
    this.getFilter(this.filter);
  }

  async mounted() {
    await this.getHistoryFollowUpIncoming(new HistoryFollowUpIncomingRequest());
  }

  getFilter = debounce((filter: Partial<HistoryFollowUpIncomingRequest>) => {
    this.filter = new HistoryFollowUpIncomingRequest(filter);
    this.getHistoryFollowUpIncoming(this.filter);
  }, 250);

  async getHistoryFollowUpIncoming(params: HistoryFollowUpIncomingRequest) {
    try {
      this.isLoading = true;
      const res = await SttHangingController.getHistoryFollowUpIncoming(params);
      this.historyFollowUpIncoming = res.data;
      this.pagination = res.pagination
      this.errorState = "";
    } catch (err) {
      this.errorState = "Failed to load data.";
      this.historyFollowUpIncoming = [];
    } finally {
      this.isLoading = false;
    }
  }

  async toPage(page: number) {
    if (page === this.pagination.page) {
      return;
    }
    this.pagination.page = page;
    this.filter = new HistoryFollowUpIncomingRequest({
      ...this.filter,
      page: page
    });
    await this.getHistoryFollowUpIncoming(this.filter);
  }

  mapActivityType(activitie: ActivitiesDetail) {
    const label: any = {
      "follow_up_airport": this.$t("dashboard.hanging.followUpAirport"),
      "follow_up_courier_truck": `${this.$t("dashboard.hanging.followUpCourierTruck")} ${activitie.followUp?.courierName}`,
      "follow_up_checker": `${this.$t("dashboard.hanging.followUpChecker")} ${activitie.followUp?.username}`,
      "follow_up_warehouse": this.$t("dashboard.hanging.searchSttWarehouse"),
      "follow_up_konsol": `${this.$t("dashboard.hanging.followUpConsole")} ${activitie.followUp?.origin3lc} - ${activitie.followUp?.originName}`
    }

    const icon: any = {
      "follow_up_airport": "ic_plane_hanging",
      "follow_up_courier_truck": "ic_truck_hanging",
      "follow_up_checker": "ic_checker_hanging",
      "follow_up_warehouse": "ic_search_hanging",
      "follow_up_konsol": "ic_console_hanging"
    }

    return {
      label: label[activitie.activityType] ?? this.$t("dashboard.hanging.followUpAirport"),
      icon: icon[activitie.activityType] ?? "ic_plane_hanging"
    }
  }

  formatDateToString(date: string) {
    return formatDate(date);
  }
}
export default TabRiwayatFollowUpIncoming;
